var _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEclipse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 186,
    viewBox: "40 0 163 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_2033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 163,
    height: 186
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.5,
    cy: 93.4038,
    rx: 81.5,
    ry: 92.5962,
    transform: "rotate(-180 81.5 93.4038)",
    fill: "#ffffff",
    fillOpacity: 0.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_2033)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 146.235,
    width: 331,
    height: 163.606,
    rx: 8,
    transform: "rotate(-180 353 146.235)",
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse2);
export default __webpack_public_path__ + "static/media/eclipse2.281e2aeea0c62bc1da4cece24648df86.svg";
export { ForwardRef as ReactComponent };